export interface ActivityFiltersState {
  q: string;
  priority: string;
  country: string;
}

export const NO_ACTIVITY_FILTERS: ActivityFiltersState = { q: "", priority: "", country: "" };
